// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.C6hXTwQpHCy62c {
  position: initial;
  top: 0;
  align-self: auto;
  max-width: 100%;
  margin-right: 0;
  padding: 0;
}
.C6hXTwQpHCy62c .GYXAdAaPGVuojG {
  display: none;
}
.C6hXTwQpHCy62c .GYXAdAaPGVuojG.uSUUTtHEQ7xx_F {
  display: block;
  position: absolute;
  z-index: 3;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 32px;
  overflow: scroll;
  background-color: var(--ds-surface, #ffffff);
}
.C6hXTwQpHCy62c .Wn1azEFVijb_kY {
  display: flex;
}
.GokoDG9iSX4yXv {
  position: sticky;
  top: 32px;
  align-self: flex-start;
  min-width: 240px;
  max-width: 240px;
  margin-right: 16px;
  padding: 0 16px;
  overflow: auto;
}
@media only screen and (max-width: 600px) {
  .GokoDG9iSX4yXv {
    position: initial;
    top: 0;
    align-self: auto;
    max-width: 100%;
    margin-right: 0;
    padding: 0;
  }
  .GokoDG9iSX4yXv .GYXAdAaPGVuojG {
    display: none;
  }
  .GokoDG9iSX4yXv .GYXAdAaPGVuojG.uSUUTtHEQ7xx_F {
    display: block;
    position: absolute;
    z-index: 3;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-bottom: 32px;
    overflow: scroll;
    background-color: var(--ds-surface, #ffffff);
  }
  .GokoDG9iSX4yXv .Wn1azEFVijb_kY {
    display: flex;
  }
}
@media only screen and (max-width: 860px) {
  .GokoDG9iSX4yXv.VTx6eIxIInkiFn {
    position: initial;
    top: 0;
    align-self: auto;
    max-width: 100%;
    margin-right: 0;
    padding: 0;
  }
  .GokoDG9iSX4yXv.VTx6eIxIInkiFn .GYXAdAaPGVuojG {
    display: none;
  }
  .GokoDG9iSX4yXv.VTx6eIxIInkiFn .GYXAdAaPGVuojG.uSUUTtHEQ7xx_F {
    display: block;
    position: absolute;
    z-index: 3;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-bottom: 32px;
    overflow: scroll;
    background-color: var(--ds-surface, #ffffff);
  }
  .GokoDG9iSX4yXv.VTx6eIxIInkiFn .Wn1azEFVijb_kY {
    display: flex;
  }
}
.GokoDG9iSX4yXv li {
  margin: 4px 0;
}
.Wn1azEFVijb_kY {
  display: none;
  position: sticky;
  top: 0;
  justify-content: space-between;
  height: 16px;
  margin-bottom: 16px;
  padding: 16px 16px;
  background-color: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  font-weight: var(--ds-font-weight-bold, bold);
  cursor: pointer;
}
.px19wg03mvkB4B {
  width: 30px;
  font-size: 20px;
}
li.SUIZwWWDtNVSxp {
  margin-top: 18px;
}
.lqrUOD2wFKDkzO {
  margin-top: 8px;
  margin-left: 25px;
}
.RKnEwBkHMyzH19 {
  display: flex;
  align-items: center;
  padding: 4px 10px;
  overflow: hidden;
  border-radius: 4px;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 24px;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}
.RKnEwBkHMyzH19:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  color: var(--ds-text, #172b4d);
}
.RKnEwBkHMyzH19._VUhls7Lk5IbNk {
  padding-left: 32px;
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-regular, normal);
}
.wfBtiSqM4LDMr3 {
  display: block;
  flex: 0 0 auto;
  margin-right: 8px;
  text-align: center;
}
.wGZ7THw5gyeZ8b.RKnEwBkHMyzH19 {
  background-color: var(--ds-background-accent-blue-subtlest, #e9f2ff);
  font-weight: var(--ds-font-weight-bold, bold);
}
.wGZ7THw5gyeZ8b.RKnEwBkHMyzH19,
.wGZ7THw5gyeZ8b.RKnEwBkHMyzH19:hover,
.wGZ7THw5gyeZ8b.RKnEwBkHMyzH19 .wfBtiSqM4LDMr3 svg {
  color: var(--ds-background-accent-blue-bolder, #0c66e4);
}
.JnPGFhEvk2R2Lh {
  margin-bottom: 8px;
}
.uSUUTtHEQ7xx_F .JnPGFhEvk2R2Lh {
  padding: 0 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"extraSmallDirectorySidebar": `C6hXTwQpHCy62c`,
	"navigation": `GYXAdAaPGVuojG`,
	"expanded": `uSUUTtHEQ7xx_F`,
	"responsiveNavigator": `Wn1azEFVijb_kY`,
	"directorySidebar": `GokoDG9iSX4yXv`,
	"workspaceNavigationExpanded": `VTx6eIxIInkiFn`,
	"responsiveNavigatorIcon": `px19wg03mvkB4B`,
	"directoryCategories": `SUIZwWWDtNVSxp`,
	"directoryNavigationCategories": `lqrUOD2wFKDkzO`,
	"navigationLink": `RKnEwBkHMyzH19`,
	"categoryLink": `_VUhls7Lk5IbNk`,
	"navigationLinkIcon": `wfBtiSqM4LDMr3`,
	"isActive": `wGZ7THw5gyeZ8b`,
	"navigationSection": `JnPGFhEvk2R2Lh`
};
export default ___CSS_LOADER_EXPORT___;
